export default __webpack_public_path__ + "static/media/crop.07e89995.svg";